import React from 'react';
import Icon from '../../../components/AppIcon';

const CollectionOverview = ({ collections, totalValue, monthlyChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {/* Total Portfolio Value */}
      <div className="bg-card border border-border rounded-lg p-6 premium-hover">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="DollarSign" size={24} className="text-primary" />
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-card-foreground">${totalValue?.toLocaleString()}</div>
            <div className={`text-sm flex items-center ${monthlyChange >= 0 ? 'text-success' : 'text-destructive'}`}>
              <Icon name={monthlyChange >= 0 ? "TrendingUp" : "TrendingDown"} size={16} className="mr-1" />
              {monthlyChange >= 0 ? '+' : ''}{typeof monthlyChange === 'number' ? monthlyChange?.toFixed(2) : monthlyChange}%
            </div>
          </div>
        </div>
        <div className="text-sm text-muted-foreground">Total Portfolio Value</div>
        <div className="text-xs text-muted-foreground mt-1">Last updated: Oct 1, 2025</div>
      </div>
      {/* Total Items */}
      <div className="bg-card border border-border rounded-lg p-6 premium-hover">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-conversion-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="Package" size={24} className="text-conversion-accent" />
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-card-foreground">{collections?.reduce((sum, cat) => sum + cat?.items, 0)}</div>
            <div className="text-sm text-success flex items-center">
              <Icon name="Plus" size={16} className="mr-1" />
              +12 this month
            </div>
          </div>
        </div>
        <div className="text-sm text-muted-foreground">Total Items</div>
        <div className="text-xs text-muted-foreground mt-1">Across all categories</div>
      </div>
      {/* Categories */}
      <div className="bg-card border border-border rounded-lg p-6 premium-hover">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-warning/10 rounded-lg flex items-center justify-center">
            <Icon name="Grid3X3" size={24} className="text-warning" />
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-card-foreground">{collections?.length}</div>
            <div className="text-sm text-muted-foreground">Active</div>
          </div>
        </div>
        <div className="text-sm text-muted-foreground">Collection Types</div>
        <div className="text-xs text-muted-foreground mt-1">Diversified portfolio</div>
      </div>
      {/* Performance Score */}
      <div className="bg-card border border-border rounded-lg p-6 premium-hover">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-trust-builder/10 rounded-lg flex items-center justify-center">
            <Icon name="Award" size={24} className="text-trust-builder" />
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-card-foreground">A+</div>
            <div className="text-sm text-success">Excellent</div>
          </div>
        </div>
        <div className="text-sm text-muted-foreground">Portfolio Score</div>
        <div className="text-xs text-muted-foreground mt-1">Based on diversification</div>
      </div>
    </div>
  );
};

export default CollectionOverview;